import React,{ useEffect, useRef } from 'react'
import './hero.scss'
import ImageLeft from './../../components/image'
import Scroll from './../scroll/scroll';
import useBio from './../../hooks/getBio/useBio';
import { gsap, Power3 } from "gsap";
import Image from "gatsby-image"

const Hero = () => {

    const titleRef = useRef(null);
    const bio = useBio();

    useEffect(() => {
        gsap.to(titleRef.current,2,{y:0,opacity:1,ease:Power3.easeInOut},0);
    }, [])

    return (
      <>
        <div className="hero">
          <div className="animated__square"></div>
          <div className="hero__content container">
            <div className="hero__img">
              <div className="hero__img__container">
                <Image fluid={bio.img.fluid} alt={"..."} />
              </div>
              <span>Hi :)</span>
            </div>
            <div ref={titleRef} className="title-container no-select">
              <h1 className="title__name">Lester Barahona</h1>
              <small className="title__small">Software</small>
              <span className="title__dev">Developer</span>
            </div>
          </div>
          <div className="animated__circle"></div>
          <Scroll />
        </div>
        <div className="principal__img">
          <ImageLeft />
        </div>
      </>
    )
}

export default Hero
